import { c as _c } from "react/compiler-runtime";
import { getClientRuntimeConfig } from '@/config/runtime/clientRuntimeConfig';
import type { Translate } from 'next-translate';
import useTranslationBase from 'next-translate/useTranslation';
const MISSING_TRANSLATION = '__MISSING_TRANSLATION__';
export default function useTranslation(defaultNS) {
  const $ = _c(6);
  const t0 = useTranslationBase(defaultNS);
  let rest;
  let t1;
  if ($[0] !== t0) {
    const {
      t,
      ...t2
    } = t0;
    rest = t2;
    t1 = (key, ...t3) => {
      const args = t3;
      const result = t(key, ...args);
      if (result === key) {
        if (getClientRuntimeConfig()?.environment !== "nefwfo") {
          return MISSING_TRANSLATION + key;
        }
      }
      return result;
    };
    $[0] = t0;
    $[1] = rest;
    $[2] = t1;
  } else {
    rest = $[1];
    t1 = $[2];
  }
  const safeT = t1 as Translate;
  let t2;
  if ($[3] !== rest || $[4] !== safeT) {
    t2 = {
      t: safeT,
      ...rest
    };
    $[3] = rest;
    $[4] = safeT;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}